import { useEffect, useState } from 'react';
import { BASE_URL } from '../constants/urls';
import axios from 'axios';

const useStoreList = () => {

    const [listStores, setListStores] = useState([]);
    const [loadingListStores, setLoadingListStores] = useState(true);
    const [errorListStores, setErrorListStores] = useState(null);

    useEffect(() => {

        const fetchstoresList = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/store/alphabetical-list`, {
                    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`}
                });
                setListStores(res.data)
            } catch (err) {
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                errorListStores(msg);
            } finally {
                setLoadingListStores(false);
            }
        };

        fetchstoresList();
    }, []);

    return { listStores, loadingListStores, setErrorListStores };
}

export default useStoreList